import React from 'react';
import classnames from 'classnames';

import styles from './styles.less';
import responsiveStyles from '../responsive-layout/styles.less';

/**
 * @typedef {import('./gap').Gap} Gap
 */

/**
 * @typedef {import('../responsive-layout/responsive-width').ResponsiveWidth} ResponsiveWidth
 */

/**
 * @typedef {object} FlexRowProps
 * @property {React.ReactNode} children - The children to render in the row.
 * @property {string} [className] - The className to apply to the row.
 * @property {string} [ariaLabel] - The aria-label to apply to the row.
 * @property {object} [style] - The style to apply to the row.
 * @property {string} [testId] - The test id to apply to the row.
 * @property {Gap} [gap] - The gap size to apply to the row.
 * @property {ResponsiveWidth} [responsiveWidth] - The responsive width to apply to the row.
 * @property {() => void} [onClick]
 */
export const FlexRow = React.forwardRef(
  /**
   * @param {FlexRowProps} props
   * @param {React.Ref<HTMLDivElement>} ref
   * @returns {JSX.Element}
   */
  ({ ariaLabel, children, className, onClick, style, testId, gap, responsiveWidth }, ref) => (
    <div
      ref={ref}
      aria-label={ariaLabel}
      className={classnames(
        styles['flex-row'],
        responsiveWidth ? responsiveStyles[responsiveWidth] : undefined,
        gap ? styles[gap] : undefined,
        className,
      )}
      data-testid={testId}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  ),
);
